import React from 'react';
import format from 'string-format';
import PropTypes from 'prop-types';
import IdBar from '../IdBar';
import Truncate from '../Truncate';
import resx from '../../../utilities/resx';
import { RESX_REBLASTS } from '../../../Constants';

const Container = ({ data, user }) => {
    const primaryUser = {
        City: user.City,
        Country: user.Country,
        CountryId: user.CountryId,
        FirmName: user.FirmName,
        FirmUniqueName: user.FirmUniqueName,
        FirstName: user.FirstName,
        LastName: user.LastName,
        Latitude: user.UserLatitude,
        Longitude: user.UserLongitude,
        State: user.Province,
        UserDomain: user.DomainUrl,
        WebsiteId: user.WebsiteId,
        HasProfileBadge: user.HasProfileBadge,
        HasPremiumPlusBadge: user.HasPremiumPlusBadge
    };

    const secondaryUser = {
        City: data.Reblast.City,
        Country: data.Reblast.Country,
        CountryId: data.Reblast.CountryId,
        FirmName: data.Reblast.FirmName,
        FirmUniqueName: data.Reblast.FirmUniqueName,
        FirstName: data.Reblast.FirstName,
        LastName: data.Reblast.LastName,
        Latitude: data.Reblast.UserLatitude,
        Longitude: data.Reblast.UserLongitude,
        State: data.Reblast.Province,
        UserDomain: data.Reblast.DomainUrl,
        WebsiteId: data.Reblast.WebsiteId,
        HasProfileBadge: data.Reblast.HasProfileBadge,
        HasPremiumPlusBadge: data.Reblast.HasPremiumPlusBadge
    };
    return (
        <article
            className="single-reblast-container re-useractivity-feed-container"
            data-testid="SingleReblastContainer"
            data-reblastid={data.Reblast.ContentId}
        >
            <div className="re-reblast-idbar re-reblast-idbar-containerwithactions">
                <IdBar date={data.CreatedOnFormatted} user={primaryUser} />
            </div>
            {data.UserActivityType === 1 ? (
                <div
                    data-testid="userliked"
                    className="re-useractivity-feed-message"
                    dangerouslySetInnerHTML={{
                        __html: format(
                            resx(RESX_REBLASTS, 'USER_ACTIVITY_LIKED'),
                            data.ContentLink,
                            secondaryUser.FirstName,
                            secondaryUser.LastName
                        )
                    }}
                />
            ) : null}

            {data.UserActivityType === 2 ? (
                <React.Fragment>
                    <div
                        data-testid="usercommented"
                        className="re-useractivity-feed-message"
                        dangerouslySetInnerHTML={{
                            __html: format(
                                `Commented on a <a href=${data.ContentLink}>post</a> by ${secondaryUser.FirstName} ${secondaryUser.LastName}`
                            )
                        }}
                    />
                    <div className="re-useractivity-comment-conatiner" data-testid="usercomment">
                        <Truncate
                            className="re-useractivity-comment-conatiner-message"
                            content={data.CommentText}
                            targetLength={120}
                        />
                    </div>
                </React.Fragment>
            ) : null}

            <div className="re-useractivity-feed-previw">
                <IdBar date={data.Reblast.CreatedOnFormatted} user={secondaryUser} />
                <Truncate
                    className="re-useractivity-feed-previw-message"
                    content={data.Reblast.Message}
                    targetLength={120}
                />
                <a href={data.ContentLink} className="re-useractivity-feed-link">
                    {resx(RESX_REBLASTS, 'SEE_MORE')}
                </a>
            </div>
        </article>
    );
};

Container.propTypes = {
    data: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
};

export default Container;
